export default function Footer({onMyVideosClick, onGenerateClick}) {
    return (
        <footer className="bg-brand-gray py-10">
            <div className="max-w-[1110px] mx-auto px-4">
                <div className="flex flex-col gap-6 md:flex-row md:justify-between items-start mb-6">
                    <div className="flex flex-col items-start">
                        <span className="text-2xl font-bold text-brand-dark">selebrus<span
                            className="text-brand-red">.</span><span className="text-brand-dark/50">ru</span></span>
                        <span className="text-[16px] text-brand-dark/50" style={{fontFamily: 'Poppins, sans-serif'}}>сервис поздравлен<span className="text-[20px] text-brand-red">ИИ</span>й</span>
                    </div>

                    <div className="flex flex-col gap-4 md:flex-row md:gap-8">
                        <a href="#" onClick={(e) => { e.preventDefault(); onMyVideosClick(); }}
                           className="text-lg font-medium text-brand-dark hover:text-brand-red transition tracking-[-0.18px]">Мои
                            видео</a>
                        <a href="#" onClick={(e) => { e.preventDefault(); onGenerateClick(); }}
                           className="text-lg font-medium text-brand-dark hover:text-brand-red transition tracking-[-0.18px]">На главную</a>
                        <a href="/blog/"
                           className="text-lg font-medium text-brand-dark hover:text-brand-red transition tracking-[-0.18px]">Блог</a>
                        <a href="https://t.me/selebrushelpbot" target="_blank" rel="noopener noreferrer"
                           className="text-lg font-medium text-brand-dark hover:text-brand-red transition tracking-[-0.18px]">Поддержка</a>
                    </div>
                </div>

                <div className="flex flex-col gap-4 md:flex-row md:justify-between items-start md:items-center">
                    <p className="text-sm font-medium text-brand-dark/60 leading-[1.1] tracking-[-0.14px]">
                        <span>E-mail: <a href="mailto:selebovich@yandex.ru">selebovich@yandex.ru</a></span>
                        <br/>
                        2026 Все права защищены
                    </p>
                    <div className="flex flex-col gap-2 md:flex-row md:gap-8">
                        <a href="/refund-policy.html"
                           className="text-sm font-medium text-brand-dark/60 underline hover:text-brand-red transition tracking-[-0.14px]">
                            Политика возврата
                        </a>
                        <a href="/privacy-policy.html"
                           className="text-sm font-medium text-brand-dark/60 underline hover:text-brand-red transition tracking-[-0.14px]">
                            Политика обработки персональных данных
                        </a>
                        <a href="/terms.html"
                           className="text-sm font-medium text-brand-dark/60 underline hover:text-brand-red transition tracking-[-0.14px]">
                            Условия
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
